import { TabViewModel } from '@core/models/tab-view.model';

export const PARTNER_DETAIL_TABS_VIEW: Array<TabViewModel> = [
  {
    index: 0,
    title: 'companies.detailTabs.general.label',
    route: 'general',
  },
  {
    index: 1,
    title: 'companies.detailTabs.users.label',
    route: 'users',
  },
];
